import {GET, POST} from "../util";

const inspectionUrl = "api/company-data-inspection";
const operationUrl = "api/company-data-operation";

const url = {
	inspection: {
		data: `${inspectionUrl}/data`,
		putOptionSettingStatus: `${inspectionUrl}/put-option-setting/status`,
		isCofaceToSAccepted:  `${inspectionUrl}/coface-tos/is-accepted`,
		getCompanyInsurancePolicyHolderStatus: `${inspectionUrl}/tci/status`
	},
	operation: {
		applyPutOptionTrading: `${operationUrl}/put-option-setting/apply-trading`,
		acceptCofaceTOS: `${operationUrl}/coface-tos/accept`,
		confirmTciRequest: `${operationUrl}/tci/accept`
    }
};

const companyProfileApi = {
    inspection: {
        getData: () => {
            return GET(url.inspection.data);
        },
		getPutOptionSettingStatus: () => {
			return GET(url.inspection.putOptionSettingStatus);
		},
		isCofaceToSAccepted: () => {
			return GET(url.inspection.isCofaceToSAccepted);
		},
		getCompanyInsurancePolicyHolderStatus: () => {
			return GET(url.inspection.getCompanyInsurancePolicyHolderStatus);
		}
    },
    operation: {
		applyPutOptionTrading: (data) => {
			return POST(url.operation.applyPutOptionTrading, data);
		},
		acceptCofaceTOS: (data) => {
			return POST(url.operation.acceptCofaceTOS, data);
		},
		acceptTciTOS: (data) => {
			return POST(url.operation.confirmTciRequest, data);
		}
    }

};
export {
    companyProfileApi
};